import axios from "axios";
import { make } from "vuex-pathify";

import { tz } from "../../../utils/timezone";
import moment from "moment";
//import momentTz from "moment-timezone";


const url = require("../../client_config/config").url;

const state = {
  habPlans: [],
  habSigned: [],
  habUnsigned: [],
  dialog: null,
  isSaving: false,
  isLoading: false,
  isSelectedMultipleItem: false,
  isDisableButton: true,
  confirmedDialog: false,
  snackbar: { show: false, text: "", color: "green accent-4" },
};

const getters = {
  getHABPlans: (state) => state.habPlans,
  getHABSigned: (state) => state.habSigned,
  getHABUnsigned: (state) => state.habUnsigned,
};

const actions = {
  async fetchHABPlans({commit}, clientId){
    commit("SET_LOADING", true);
    try{
        const response = await axios.get(`${url}/hab/client/${clientId}`);
        commit("SET_HAB_PLANS", response.data.HABPlans);
        commit("SET_LOADING", false);

        return response.data.HABPlans;
    }catch (error){
        return error;
    }
  },

  async addHABSigned({ commit }, data) {
    // commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/hab/addSigned`, data);
      console.log(data.customDate);
      response.data.customDate =  moment(new Date(data.customDate)).format("YYYY-MM-DD");
      commit("ADD_HAB_SIGNED", response.data);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "HAB successfully added",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );

      // commit("SET_LOADING", false);
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async fetchHABSigned({commit}, data){
    try{
        const response = await axios.post(`${url}/hab/getSigned`, data);
        commit("SET_HAB_SIGNED", response.data.HABSigned);
        return response.data.HABSigned;
    }catch (error){
        return error;
    }
  },

  async addHABUnsigned({commit}, data){
    try{
        const response = await axios.post(`${url}/hab/addUnsigned`, data);
        console.log("testing unsigned!!")
        commit("SET_IS_SAVING", true);
        return response;
    }catch (error){
        return error;
    }
  },

  async fetchHABUnsigned({ commit }, data) {
    console.log(data);
    try {
      const response = await axios.get(`${url}/hab/getUnsigned/${data.id}`);
      console.log(response);
      const habs = response.data.HABUnsigned.map((item) => {
        item.Date = moment(item.Date).format("YYYY-MM-DD");
        return {
          ...item,
          Date: tz(item.Date, data.userTimezone).format("YYYY-MM-DD"),
        };
      });

      commit("SET_HAB_UNSIGNED", habs);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

};

const mutations = {
  ...make.mutations(state),

  SET_HAB_PLANS(state, data){
      state.habPlans = data;
  },

  SET_HAB_SIGNED(state, data){
    state.habSigned = data;
  },

  ADD_HAB_SIGNED(state, data) {
    state.habSigned.push(data);
  },

  SET_HAB_UNSIGNED(state, data){
    state.habUnsigned = data;
  },

  SET_LOADING(state, data){
      state.isLoading = data;
  },

  SET_IS_SAVING(state, data){
      state.isSaving = data;
  },

  SET_IS_SELECTED_MULTIPLE_ITEM(state, data){
      state.isSelectedMultipleItem = data;
  },

  SET_CONFIRMED_DIALOG(state, data) {
      state.confirmedDialog = data;
  },

  SET_DISABLE_BUTTON(state, data) {
    state.isDisableButton = data;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};